var _style, _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTeDhenat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1080 1080",
    style: {
      enableBackground: "new 0 0 1080 1080"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{clip-path:url(#SVGID_00000121990055501058428190000006630622562514405798_);}\r\n\t.st1{fill:#1F2835;}\r\n")), /*#__PURE__*/React.createElement("g", {
    id: "Group_615",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 97.08,
    y: 165.53,
    width: 885.84,
    height: 770.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000059291507418979069040000015138321954983749532_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_612",
    transform: "translate(0 0)",
    style: {
      clipPath: "url(#SVGID_00000059291507418979069040000015138321954983749532_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_5638",
    className: "st1",
    d: "M982.65,375.5c-0.04-7.61-1.06-15.19-3.03-22.54c-10.13-42.22-49.2-71.01-92.53-68.17 c-122.49,0-245,0-367.53,0c-6.57,0.44-12.94-2.38-17.03-7.55c-29.7-35.38-59.79-70.27-89.89-105.21 c-2.8-3.28-6.74-5.38-11.02-5.9c-45.52-0.55-91.43-0.99-137.22,0c-44.9-0.39-83.29,32.23-90.16,76.6 c-1.51,13.41-2.25,26.9-2.2,40.4c-46.23,6.16-79.33,47.75-74.95,94.18c0.94,156.18,0,312.37,0.55,468.44 c-0.2,11.17,1.23,22.31,4.24,33.07c11.08,36.01,45.46,59.69,83.05,57.2h539.37c26.01,0,52.13,0,78.26,0 c45.65,0.88,83.37-35.41,84.25-81.05c0.01-0.54,0.02-1.08,0.02-1.61c0-4.24,0-8.54,0-13.06l6.06-0.55 c50.32-0.82,90.48-42.21,89.77-92.53c0.26-123.74,0.26-247.52,0-371.33 M940.98,743.42c2,26.3-16.76,49.65-42.88,53.35 c-3.03,0.39-6.17,0.39-10.58,0.66v-11.96c0-98.98,0-197.92,0-296.82c2.08-36.21-20.16-69.4-54.45-81.23 c-10.59-3.29-21.64-4.87-32.74-4.68c-123.74-0.26-247.48-0.26-371.22,0c-7.01,0.44-13.76-2.72-17.91-8.38 c-28.99-35.05-58.69-69.55-87.85-104.71c-3.45-4.45-8.94-6.84-14.55-6.34c-30.81,0-61.61,0-94.46,0 c0.14-12.8,1.15-25.58,3.03-38.25c5.24-21.07,24.09-35.9,45.8-36.04c39.46-0.26,78.92-0.26,118.38,0 c4.15,0.42,7.99,2.38,10.75,5.51c30.49,35.34,60.68,70.76,90.55,106.25c3.68,4.68,9.43,7.26,15.38,6.89 c129.23,0,258.36,0.39,387.59-0.55c29.35-1.24,54.14,21.55,55.38,50.89c0.06,1.41,0.06,2.81,0.01,4.22 c-0.66,120.31,0,240.45,0,360.75"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeDhenat);
export default __webpack_public_path__ + "static/media/te-dhenat.a18b1dc6e1a3c438928b629983ed88c2.svg";
export { ForwardRef as ReactComponent };